export default [
	{
		path: "/sportonline/:id(\\d+)/:item_id?",
		name: "_sport2022",
		component: () => import("../views/Sport2022/home/Index"),
		meta: {
			title: "全民健身线上运动会",
			showloading: false,
			requiresAuth: true,
			keepAlive: false,
			bgcolor: "#0092e5"
		}
	},
	{
		path: "/sportcommon/:id(\\d+)/:item_id?",
		name: "_sportcommon",
		component: () => import("../views/Sport2022/comhome/Index"),
		meta: {
			title: "全民健身线上运动会",
			showloading: false,
			requiresAuth: true,
			keepAlive: false
		}
	},
	// 嘉定定制活动
	{
		path: "/jdsportcommon/:id(\\d+)/:item_id?",
		name: "_sportcommon2",
		component: () => import("../views/Sport2022/comhome/Index2"),
		meta: {
			title: "活动详情",
			showloading: false,
			requiresAuth: true,
			keepAlive: false
		}
	},
	// 嘉定定制活动
	{
		path: "/jdrank",
		name: "jdrank",
		component: () => import( /* webpackChunkName: "Orient" */ "../views/Sport2022/Rank/index.vue"),
		meta: {
			title: "排行榜",
			showloading: true,
			requiresAuth: true,
			bgcolor: "#4693FF"
		}
	},
	{
		path: "/newanswer/:acid/:sub_aid?",
		name: "newanswer",
		component: () => import("../views/Sport2022/Answer/Index"),
		meta: {
			title: "天天答题",
			showloading: false,
			requiresAuth: true,
			keepAlive: false
		}
	},
	{
		path: "/answerrank/:acid",
		name: "answerRank",
		component: () => import("../views/Sport2022/Answer/rank"),
		meta: {
			title: "答题排行",
			showloading: false,
			requiresAuth: true,
			keepAlive: false,
			bgcolor: "#0092e5"
		}
	},
	{
		path: "/lunanswer/:acid/:sub_aid?",
		name: "lunnewanswer",
		component: () => import("../views/Sport2022/LhAnswer/Index"),
		meta: {
			title: "天天答题",
			showloading: false,
			requiresAuth: true,
			keepAlive: false,
			bgcolor: "#ffffff"
		}
	},
	{
		path: "/lunanswerrank/:acid",
		name: "lunanswerRank",
		component: () => import("../views/Sport2022/LhAnswer/rank"),
		meta: {
			title: "答题排行",
			showloading: false,
			requiresAuth: true,
			keepAlive: false,
			bgcolor: "#3B6967"
		}
	},
	{
		path: "/showlist",
		name: "showlist",
		component: () => import("../views/Sport2022/showlist/index"),
		meta: {
			title: "教学视频",
			showloading: false,
			requiresAuth: false,
			keepAlive: false,
			bgcolor: "#fff"
		}
	},
	{
		path: "/hkshowlist",
		name: "hkshowlist",
		component: () => import("../views/Sport2022/showlist/hkindex"),
		meta: {
			title: "教学视频",
			showloading: false,
			requiresAuth: false,
			keepAlive: false,
			bgcolor: "#fff"
		}
	},
	{
		path: "/viewlist/:itemid",
		name: "viewlist",
		component: () => import("../views/Sport2022/showlist/home"),
		meta: {
			title: "教学视频",
			showloading: false,
			requiresAuth: true,
			keepAlive: false,
			bgcolor: "#fff"
		}
	},
	{
        path: "/sports2022/detail/:sports_id/:item_id/:acid?",
        name: "Detail2022",
        props:true,
        component: () => import(/* webpackChunkName: "home" */"../views/Sport2022/Detail/index.vue"),
        meta: {
            requiresAuth: true,
            showloading: false,
            title:"详情",
			bgcolor: "#6691DB"
        }
    },
	{
		path: "/skeleton/:item_sub_id/:sports_id",
		name: "skeleton",
		component: () => import("../views/Sport2022/Result/Index.vue"),
		meta: {
			title: "海报分享",
			showloading: false,
			requiresAuth: true,
			keepAlive: false,
			bgcolor: "#fff"
		}
	},
];
